export default function PHP_OOPIntro() {
  return (
    <div>
      <h1>PHP_OOPIntro</h1>
    </div>
  );
}
